import React, { Component } from 'react';
import { PropTypes } from 'prop-types';
import './MobileDownloadInfo.css';

const ANDROID_APP_LINK = 
    'https://play.google.com/store/apps/details?id=com.bitstrips.imoji&referrer=utm_source%3Dchrome-extension';
const IOS_APP_LINK = 'https://apps.apple.com/app/apple-store/id868077558?pt=561909&ct=chrome-extension&mt=8';
class MobileDownloadInfo extends Component {
    render() {
        const { title, text} = this.props;

        return (
            <div className="mobile-info-container">
                <div className="left-col">
                    <div className="graphic-signup" />
                </div>
                <div className="right-col">
                    <div className="signup-title">
                        <p>{title}</p>
                    </div>
                    <div className="signup-text">
                        <p>{text}</p>
                    </div>
                    <div className="app-info" id="mobile-app-information" >
                        <a href={IOS_APP_LINK} id="link-to-itunes-app-store">
                            <div className="badge-ios-xl" />
                        </a>
                        <a href={ANDROID_APP_LINK} id="link-to-android-app-store">
                            <div className="badge-android-xl" />
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}

MobileDownloadInfo.propTypes = {
    title: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
};


export default MobileDownloadInfo;



// WEBPACK FOOTER //
// ./src/components/login_view/MobileDownloadInfo.js